module.exports = __webpack_public_path__ + "static/media/fitness-img.ceebd70d.jpg";